import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ApiUser } from '../services/apiService';
import { EntityConfig } from '../services/entityApiService';

interface UserContextType {
    user: ApiUser | null;
    setUser: (user: ApiUser | null) => void;
    isAdmin: boolean;
    entityConfig: EntityConfig | null;
    setEntityConfig: (config: EntityConfig | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<ApiUser | null>(null);
    const [entityConfig, setEntityConfig] = useState<EntityConfig | null>(null);
    const isAdmin = user?.userRole === 'Admin';

    return (
        <UserContext.Provider value={{ user, setUser, isAdmin, entityConfig, setEntityConfig }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
